<template>
    <div class="flex flex-row items-center gap-2">
        <router-link v-if="manage_link" :to="manage_link" target="_blank" class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border p-2">
            <feather-icon icon="ArrowUpRightIcon" svgClasses="text-primary w-6 h-6" class="align-middle"/>
        </router-link>
        <div v-if="manage_link" class="sk-btn sk-btn-small sk-btn-primary rounded-lg btn-border p-2">
            <feather-icon icon="RefreshCwIcon" svgClasses="text-primary w-6 h-6" class="align-middle cursor-pointer" @click="$emit('refresh')"/>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    manage_link: {
      type: String,
      default: null
    }
  },
};
</script>
